// src/lib/analysisApi.js
// 레거시 analysis.js의 텍스트/구성 1:1 유지 (번역/가공 금지)

export function getLang() {
  return (typeof document !== "undefined" && document.documentElement?.lang) || "ko";
}

export function getTitlesByLang(lang) {
  if (lang === "zh-CN") {
    return {
      appTitle: process.env.REACT_APP_CN_CLINIC_NAME,
      appSubtitle: "患者行为类型分类器 | 初诊咨询辅助工具",
      step1Title: "STEP 1. 自我管理倾向把握",
      step1Desc: "通过患者日常生活管理模式确认自发性水平。",
      step1Legend: "“最近在饮食、睡眠、运动等方面，是能够自我调节的类型？还是有些动摇？”",

      step2Title: "STEP 2. 指南接受态度把握",
      step2Desc: "通过对生活习惯矫正的开放程度预测就诊参与度。",
      step2Legend: "“我也可以就饮食/生活习惯给您简单建议，是否也愿意聊聊这类内容呢？”",

      step3Title: "STEP 3. 决策委托风格探索",
      step3Desc: "通过对小改变提议的反应来估量实践意志。",
      step3Legend: "“如果我根据您的状态只提议改变一件事，您能尝试一下吗？”",

      resetLabel: "重新开始",
      resultTitlePrefix: "分类结果: ",
      guideTitle: "咨询及反馈指南",
    };
  }

  // 기본(한국어)
  return {
    appTitle: process.env.REACT_APP_CLINIC_NAME,
    appSubtitle: "환자 행동유형 분류기 | 초진 상담 지원 도구",
    step1Title: "STEP 1. 자기관리 성향 파악",
    step1Desc: "환자의 평소 생활 관리 패턴을 통해 자발성 수준을 확인합니다.",
    step1Legend: "“요즘 식사나 수면, 운동 같은 거는 스스로 잘 조절하시는 편이세요? 아니면 좀 흔들리세요?”",

    step2Title: "STEP 2. 지침 수용 태도 파악",
    step2Desc: "생활습관 교정에 대한 개방성을 통해 진료 참여도를 예측합니다.",
    step2Legend: "“제가 식습관이나 생활습관 관련해서도 간단히 조언을 드릴 수 있는데, 혹시 그런 부분에 대해서도 이야기 나누는 걸 원하시나요?”",

    step3Title: "STEP 3. 결정 위임 스타일 탐색",
    step3Desc: "작은 변화 제안에 대한 반응으로 실천 의지를 가늠합니다.",
    step3Legend: "“만약 제가 환자분 상태에 맞춰 딱 한 가지만 바꿔보자고 제안드리면, 시도해 보실 수 있을까요?”",

    resetLabel: "새로 시작",
    resultTitlePrefix: "분류 결과: ",
    guideTitle: "상담 및 피드백 가이드",
  };
}

export function getPatientTypesByLang(lang) {
  if (lang === "zh-CN") {
    return {
      self_driven: {
        name: "自发型 (Self-Driven)",
        color: "bg-pink-100 border-pink-500",
        textColor: "text-pink-800",
        description:
          "具有自我主导性，基本健康习惯已形成良好。设定目标及自我管理能力出色。",
        tips: [
          "<strong>核心策略:</strong> 作为专家提出方向并提供信息",
          "基于具体数值（体脂率、肌肉量）共同设定目标",
          "建议饮食/运动以外的睡眠、压力等深化管理法",
          "称赞并支持自发动机，建立信任关系",
        ],
      },
      trigger_activated: {
        name: "潜能激发型 (Trigger-Activated)",
        color: "bg-rose-100 border-rose-500",
        textColor: "text-rose-800",
        description:
          "虽然有意志，但因频繁失败导致自信心下降。若能创造一个小小的成功契机(Trigger)，潜力就会爆发。",
        tips: [
          "<strong>核心策略:</strong> 提供微小但确定的成功体验 (Small Success)",
          "找出并建议“仅一项”最容易改变的生活习惯",
          "成功时给予即时且具体的称赞，赋予成就感",
          "分析过去失败原因，灌输“这次不同”的确信",
        ],
      },
      externally_anchored: {
        name: "环境依赖型 (Externally Anchored)",
        color: "bg-fuchsia-100 border-fuchsia-500",
        textColor: "text-fuchsia-800",
        description:
          "相比自身意志，更依赖外部持续的反馈与鼓励。对管理系统的顺应度较高。",
        tips: [
          "<strong>核心策略:</strong> 提供系统化且持续的管理体系",
          "提示定期复诊日程、通知消息等明确的时间表",
          "每次访问时哪怕微小的变化也要找出并称赞鼓励",
          "建议任务执行型挑战（例：每周3次步行认证）",
        ],
      },
      passive_dependent: {
        name: "诊疗依赖型 (Passive Dependent)",
        color: "bg-purple-100 border-purple-500",
        textColor: "text-purple-800",
        description:
          "相比自行决定，更倾向于完全依赖专家的处方和指示。虽然承认生活习惯矫正的必要性，但不具备主导性。",
        tips: [
          "<strong>核心策略:</strong> 提供明确且单纯的指南 (Instruction)",
          "相比复杂的说明，更偏好“请这样做”形式的简练指示",
          "相比给选项，更倾向于选定1~2种最有效的方法传达",
          "对患者的小问题也以具有权威和信任感的态度回答",
        ],
      },
      low_engagement: {
        name: "低参与型 (Low Engagement)",
        color: "bg-slate-100 border-slate-400",
        textColor: "text-slate-700",
        description:
          "只关注药物效果，对生活习惯矫正等额外干预感到负担。偏好最少限度的互动。",
        tips: [
          "<strong>核心策略:</strong> 以药效为中心的高效信息传达",
          "相比长篇说明，只传达服药法、预期效果、注意事项等核心信息",
          "不强迫矫正生活习惯，仅保留“如果您好奇的话”程度的余地",
          "通过快速简练的诊疗节省患者的时间和心理成本",
        ],
      },
    };
  }

  // 한국어
  return {
    self_driven: {
      name: "자발형 (Self-Driven)",
      color: "bg-pink-100 border-pink-500",
      textColor: "text-pink-800",
      description:
        "자기 주도적이며 기본적인 건강 습관이 잘 형성되어 있습니다. 스스로 목표를 설정하고 관리하는 능력이 뛰어납니다.",
      tips: [
        "<strong>핵심 전략:</strong> 전문가로서의 방향 제시 및 정보 제공",
        "구체적인 수치(체지방률, 근육량)를 기반으로 목표를 함께 설정",
        "식단/운동 외 수면, 스트레스 등 심화 관리법 제안",
        "자발적 동기를 칭찬하고 지지하여 신뢰 관계 형성",
      ],
    },
    trigger_activated: {
      name: "히든잠재형 (Trigger-Activated)",
      color: "bg-rose-100 border-rose-500",
      textColor: "text-rose-800",
      description:
        "의지는 있으나 잦은 실패 경험으로 자신감이 떨어진 상태입니다. 성공 가능한 작은 계기(Trigger)를 만들어주면 잠재력이 폭발합니다.",
      tips: [
        "<strong>핵심 전략:</strong> 작고 확실한 성공 경험(Small Success) 제공",
        "가장 바꾸기 쉬운 생활 습관 '딱 하나'만 찾아 제안",
        "성공 시 즉각적이고 구체적인 칭찬으로 성취감 부여",
        "과거 실패 원인을 분석하고 '이번엔 다르다'는 확신 심어주기",
      ],
    },
    externally_anchored: {
      name: "환경의존형 (Externally Anchored)",
      color: "bg-fuchsia-100 border-fuchsia-500",
      textColor: "text-fuchsia-800",
      description:
        "스스로의 의지보다는 외부의 지속적인 피드백과 격려에 크게 의존합니다. 관리 시스템에 대한 순응도가 높습니다.",
      tips: [
        "<strong>핵심 전략:</strong> 체계적이고 꾸준한 관리 시스템 제공",
        "정기적인 내원일정, 알림톡 등 명확한 스케줄 제시",
        "매 방문 시 작은 변화라도 찾아내어 칭찬하고 격려",
        "미션 수행형 챌린지(예: 주 3회 걷기 인증) 제안",
      ],
    },
    passive_dependent: {
      name: "진료의존형 (Passive Dependent)",
      color: "bg-purple-100 border-purple-500",
      textColor: "text-purple-800",
      description:
        "스스로 결정하기보다 전문가의 처방과 지시에 전적으로 의존하려는 성향이 강합니다. 생활습관 교정의 필요성은 인정하지만 주도적이지 않습니다.",
      tips: [
        "<strong>핵심 전략:</strong> 명확하고 단순한 지침(Instruction) 제공",
        "복잡한 설명보다 '이렇게 하세요' 형태의 간결한 지시 선호",
        "선택지를 주기보다 가장 효과적인 방법 1~2가지를 정해서 전달",
        "환자의 작은 질문에도 권위 있고 신뢰감 있는 태도로 답변",
      ],
    },
    low_engagement: {
      name: "저관여형 (Low Engagement)",
      color: "bg-slate-100 border-slate-400",
      textColor: "text-slate-700",
      description:
        "약의 효과에만 관심이 있으며, 생활습관 교정 등 추가적인 개입을 부담스러워합니다. 최소한의 상호작용을 선호합니다.",
      tips: [
        "<strong>핵심 전략:</strong> 약효 중심의 효율적인 정보 전달",
        "긴 설명보다 약 복용법, 예상 효과, 주의사항 등 핵심 정보만 전달",
        "생활습관 교정은 강요하지 않고 '혹시 궁금하시면' 정도로 여지만 남김",
        "빠르고 간결한 진료로 환자의 시간적, 심리적 비용 절감",
      ],
    },
  };
}
